import React, { useMemo } from "react";
import "../../styles/user/viewRequestDetails.css";

const ViewRequestDetails = ({
  request,
  onClose,
}) => {
  const candidateId = useMemo(() => {
    const directCandidateId =
      request?.candidateId ??
      request?.candidateid ??
      request?.candidateID;

    if (
      directCandidateId &&
      /^TRU\d+$/i.test(
        String(directCandidateId).trim(),
      )
    ) {
      return String(directCandidateId)
        .trim()
        .toUpperCase();
    }

    const message = String(
      request?.message ?? "",
    );

    const match =
      message.match(/\bTRU\d+\b/i);

    return match
      ? match[0].toUpperCase()
      : null;
  }, [request]);

  const requestType =
    request?.requestType ??
    request?.title ??
    request?.type ??
    null;

  const requestDate =
    request?.createdAt ??
    request?.requestDate ??
    request?.notificationTime ??
    null;

  const displayValue = (value) => {
    if (
      value === null ||
      value === undefined ||
      String(value).trim() === ""
    ) {
      return "N/A";
    }

    return value;
  };

  const formatRequestType = (value) => {
    if (!value) {
      return "N/A";
    }

    return String(value)
      .trim()
      .replaceAll("_", " ")
      .toLowerCase()
      .replace(/\b\w/g, (letter) =>
        letter.toUpperCase(),
      );
  };

  const formatDate = (value) => {
    if (!value) {
      return "N/A";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return date.toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleOverlayClick = (event) => {
    if (
      event.target === event.currentTarget
    ) {
      onClose();
    }
  };

  return (
    <div
      className="request-details-overlay"
      onClick={handleOverlayClick}
    >
      <div className="request-details-modal">
        <button
          type="button"
          className="request-details-close-button"
          onClick={onClose}
          aria-label="Close request details"
        >
          ×
        </button>

        <h2 className="request-details-title">
          Candidate Request Details
        </h2>

        <section className="request-details-section">
          <h3>Request Information</h3>

          <div className="request-details-grid">
            <div className="request-details-field">
              <label>Candidate ID</label>

              <input
                type="text"
                value={displayValue(candidateId)}
                readOnly
              />
            </div>

            <div className="request-details-field">
              <label>Request Type</label>

              <input
                type="text"
                value={formatRequestType(
                  requestType,
                )}
                readOnly
              />
            </div>

            <div className="request-details-field">
              <label>Request Date</label>

              <input
                type="text"
                value={formatDate(requestDate)}
                readOnly
              />
            </div>

            <div className="request-details-field full-width">
              <label>Request Message</label>

              <textarea
                rows={4}
                value={displayValue(
                  request?.message,
                )}
                readOnly
              />
            </div>
          </div>
        </section>

        <div className="request-details-footer">
          <button
            type="button"
            className="request-details-close-footer-button"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewRequestDetails;